module.exports = __webpack_public_path__ + "images/corvette5f2e6c673d896a9c37a29118c0f1db8c.png";